import { pushDataLayer } from './tagManagerConsent';

const pendingUpsellAdds: any[][] = [];

export const queueUpsellAddEvent = (products: any[]) => {
  if (products?.length) {
    pendingUpsellAdds.push(products);
  }
};

export const flushUpsellAddEvent = () => {
  const products = pendingUpsellAdds.shift();
  if (!products?.length) {
    return;
  }
  fireUpsellEvent(products);
};

export const clearQueuedUpsellAddEvent = () => {
  pendingUpsellAdds.shift();
};

const fireUpsellEvent = (productDetails: any) => {
  const tagManagerArgs: any = {
    dataLayer: {
      event: 'eec.add',
      ecommerce: {
        add: {
          actionField: {
            list: 'Upsell',
          },
        },
        products: productDetails,
      },
    },
  };
  pushDataLayer(tagManagerArgs);
};
